import VideoWrapper from './VideoWrapper';
export default VideoWrapper;